import { useEffect, useState } from "react";
import "./EinwohnerCss.css";

var MonitorApi = require("monitor-api");

export default function Einwohner({ bildInstance, tgInstance, zvInstance }) {
    const [listZvs, setListZvs] = useState([]);
    const [checksZvs, setChecksZvs] = useState({});
    const [listJahre, setListJahre] = useState([]);
    const [minJahr, setMinJahr] = useState(0);
    const [totalMin, setTotalMin] = useState(0);
    const [maxJahr, setMaxJahr] = useState(0);
    const [totalMax, setTotalMax] = useState(0);
    const [dia, setDia] = useState(false);
    const [changes, setChanges] = useState(true);

    useEffect(() => {
        tgInstance.getPresentYears((error, data) => {
            if (error) {
                console.log('err', error);
            } else {
                console.log('>>load jahre', data);
                setListJahre(data);
                setTotalMin(Math.min(...data));
                setMinJahr(Math.min(...data));
                setTotalMax(Math.max(...data));
                setMaxJahr(Math.max(...data));
            }
        })

        zvInstance.getZweckverbandSachsenZweckverbandSachsenGet((error, data) => {
            if (error) {
                console.log('err', error);
            } else {
                console.log('load zvs', data);
                setListZvs(data);
                data.map(zv => setChecksZvs(pre => ({...pre, [zv.id]: true})))
            }
        })
    }, [tgInstance, zvInstance]);

    useEffect(() => {
        setChanges(true);
    }, [checksZvs, minJahr, maxJahr]);

    const changeZvs = event => {
        console.log("val:", event.target.value)
        setChecksZvs(pre => ({...pre, [event.target.value]: event.target.checked}));
    }
    const newMin = event => {
        setMinJahr(parseInt(event.target.value));
    }
    const newMax = event => {
        setMaxJahr(parseInt(event.target.value));
    }

    const createPic = event => {
        event.preventDefault();
        if (minJahr < totalMin) {
            setMinJahr(totalMin);
        }
        if (maxJahr > totalMax) {
            setMaxJahr(totalMax);
        }
        let filter = new MonitorApi.EinwohnerZweckverbaendeFilter();
        const chosenJahre = listJahre.filter(jahr => minJahr <= jahr && maxJahr >=jahr).map(jahr => jahr);
        filter.filterJahre = chosenJahre;
        console.log('filter jahrInstance', filter)
        const chosenZvs = Object.keys(checksZvs).filter(zv => checksZvs[zv]);
        if (chosenZvs.length > 0) {
            filter.filterZvs = chosenZvs;
        }
        bildInstance.createEinwohnerReportingEinwohnerPost(filter, (error, data, response) => {
            if (error) {
                console.log('err', error);
            } else {
                console.log('erfolgreiche Übertragung');
                setChanges(false);
                setDia(`data:image/${data.type};base64,${data.bytes}`)
            }
        })
    }
    return (
        <div>
            <h3>Exemplarisches Beispiel - Einwohner pro Zweckverband</h3>
            <div style={{display: "flex"}}>
                <div className="ew-filter">
                    <ul type="none" className="ew-filter-zv">
                    <h4 className="filter-h4">Zweckverbände:</h4>
                    {listZvs && listZvs.map(zv => 
                        <li key={zv.id} className="filter-element"><input type="checkbox" value={zv.id} checked={checksZvs[zv.id]} onChange={changeZvs}/>{zv.kurz}</li>
                    )}
                    </ul>
                    <div className="ew-filter-jahre">
                        <h4 className="filter-h4">von:</h4>
                        <input type="number" onChange={newMin} value={minJahr} min={totalMin} max={totalMax} className="filter-element"/>
                        <h4 className="filter-h4">bis:</h4>
                        <input type="number" onChange={newMax} value={maxJahr} min={totalMin} max={totalMax} className="filter-element"/>
                    </div>
                    <button className={changes ? "ausw-bttn reload-please" : "ausw-bttn"} onClick={createPic}>Auswertung</button>
                    <section>
                        <p style={{fontSize: "small", margin: "0", textAlign: "center"}}>*Daten verfügbar:</p>
                        <p style={{fontSize: "small", margin: "0", textAlign: "center"}}>von {totalMin} bis {totalMax}</p>
                    </section>
                    
                </div>
                <div style={{marginLeft: "5em"}}>
                    {dia && <img src={dia} alt="Auswertung Einwohnerzahlen" />}
                    <br></br>
                    {dia && <a href={dia} download={`einwohner-${minJahr}-bis-${maxJahr}.png`}>Diagramm herunterladen</a>}
                </div>
            </div>
        </div>
    )
}